module.exports = __webpack_public_path__ + "static/media/x-icon.2d9b58ec.png";